module.exports = __webpack_public_path__ + "img/redEnvelopedRainFollowBackground.e63018bc.png";